import React from 'react';
import { Icon } from 'react-icons-kit'
import { ic_fiber_manual_record } from 'react-icons-kit/md/ic_fiber_manual_record'

import './index.css';

function Legendas(props) {
    console.log(props.legenda)
    return (
        <div style={{display: 'flex', gap: 16, alignItems: 'center', marginTop: 12}}>
            {props.legenda && props.legenda.map(situacoes => {
                return (<div style={{display: 'flex', flexDirection: 'cloumn', gap: 4, alignItems: 'center'}}> 
                    {/* <div style={{height: 10, width: 30, backgroundColor: situacoes.color}}></div> */}
                    <Icon style={{color: situacoes.color}} icon={ic_fiber_manual_record} size={16} />
                    <p style={{margin: 0}}>
                        {situacoes.descricao}
                    </p>
                </div>)
            })}

        </div>
    );
}

export default Legendas;